// extracted by mini-css-extract-plugin
export default {"tagsRow":"ActivityTagList_tagsRow__q1b9a"};